import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { stripFrontMatter } from "../../../utils/markdownHelpers";
import sdkIosFile from "../../../assets/markDownFiles/geosafe/SDK-iOS.md";

// The ACT Geo iOS SDK App Session Integration Guide. It is plain GitHub-flavoured
// markdown, so it only has its front matter removed (convertMdxToMd is not used).

const GeoSdkIntegrationIos = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (typeof sdkIosFile === "string" && sdkIosFile.startsWith("/static")) {
      fetch(sdkIosFile)
        .then((res) => res.text())
        .then((raw) => setContent(stripFrontMatter(raw)));
    } else {
      setContent(stripFrontMatter(sdkIosFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Geosafe
      </Typography>
      {content ? <MarkdownRenderer content={content} /> : <p>Loading...</p>}
    </Box>
  );
};

export default GeoSdkIntegrationIos;
